import React from 'react'

const Home = () => {

    let currentDate = new Date();
    let hrs = currentDate.getHours();
    console.log(hrs)
    let geetings = '';
    let status = '';
    let statusStyle = {};

    if (hrs > 5 && hrs < 12) {
        geetings = "Good Morning"
    } else if (hrs > 12 && hrs <= 17) {
        geetings = "Good Afternoon"
    } else if (hrs > 17 && hrs <= 23) {
        geetings = "Good Evening"
    } else {
        geetings = "Good Night"
    }

    if (hrs >= 10 && hrs < 23) {
        status = 'Open'
        statusStyle.color = "Green"
    } else {
        status = 'Closed'
        statusStyle.color = "Red"
    }

    return (
        <>
            <div className="row py-md-5">
                <div className="col-12 col-md-10 offset-md-1 py-5 text-center">
                    <img src="./restaurant/images/logo.png" alt="" style={{ maxWidth: '250px' }} />
                    <h1 className="fw-bold mb-3">Welcome to React Restaurant</h1>
                    <p className="text-info fw-bold">Timing :- 10:00 AM to 11:00 PM</p>
                    <h3 className="my-4"><span className="text-secondary">Hello Guest,</span> {geetings}</h3>
                    <p className="fw-bold"><span style={statusStyle}>Restaurant is {status}</span></p>
                </div>
            </div>
        </>
    )
}

export default Home
